import {clearfix, absCenter, colors} from '@xpertdox_js/xdstyle';

export default {
  container: {

  },
  wrapper: {
    ...clearfix,
  },
  sidebar: {
    width: '20%',
    float: 'left',
    position: 'relative',
  },
  main: {
    width: '80%',
    borderLeft: '1px solid ' + colors.xdFadedBlue,
    float: 'right',
    padding: '8px',
  }
}
